import React from 'react';
const LoadingScreen: React.FC = () => {
  const logoUrl = '/logosvg.svg'

  return (
    <div className="flex h-screen w-full items-center justify-center bg-white">
      <style>{`
        @keyframes smoothRolling {
          /* Ease in + 2.5 rotations forward (900 degrees) */
          0% { transform: rotate(0deg); }
          20% { transform: rotate(360deg); }
          40% { transform: rotate(720deg); }
          60% { transform: rotate(900deg); }

          /* Hold and ease out */
          65% { transform: rotate(900deg); }

          /* Ease in + 2.5 rotations backward (back to 0) */
          85% { transform: rotate(0deg); }

          /* Ease out and hold */
          100% { transform: rotate(0deg); }
        }

        .logo-spin {
          animation: smoothRolling 8s ease-in-out infinite;
        }

        .pulse-wave {
          animation: pulseWave 1.8s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }

        @keyframes pulseWave {
          0%, 100% {
            transform: scale(0.8);
            opacity: 0.5;
          }
          50% {
            transform: scale(1.1);
            opacity: 1;
          }
        }
      `}</style>
      <div className="flex flex-col items-center justify-center space-y-6">
        <div className="h-20 w-20 logo-spin">
          <img
            src={logoUrl}
            alt="PONS Logo"
            className="w-full h-full object-contain drop-shadow-lg"
          />
        </div>

      </div>
    </div>
  );
};

export default LoadingScreen;
